import { render } from "./ModalPrintOrder.vue?vue&type=template&id=0fbac6b2&scoped=true"
import script from "./ModalPrintOrder.vue?vue&type=script&lang=js"
export * from "./ModalPrintOrder.vue?vue&type=script&lang=js"

import "./ModalPrintOrder.vue?vue&type=style&index=0&id=0fbac6b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbac6b2"]])

export default __exports__